module.exports = __webpack_public_path__ + "img/menu.47d85d7d.svg";